// ─── Référentiels du budget (catégories, paiements, emojis) ───────
// Porté de MoPCal en passant des icônes Ionicons aux EMOJIS (canon de la suite).
// Les libellés viennent de l'i18n déjà en place : `budget.cat_*` / `budget.pmt_*`
// — on ne stocke ici que la clé et l'emoji, jamais un libellé en dur.
export const CATEGORIES = [
  { id: 'scolaire',      emoji: '🏫' },
  { id: 'sante',         emoji: '🩺' },
  { id: 'activites',     emoji: '⚽' },
  { id: 'vetements',     emoji: '👕' },
  { id: 'alimentation',  emoji: '🛒' },
  { id: 'salaire',       emoji: '💶' },
  { id: 'loyer',         emoji: '🏠' },
  { id: 'charges',       emoji: '🧾' },
  { id: 'energie',       emoji: '⚡' },
  { id: 'travaux',       emoji: '🔨' },
  { id: 'assurance',     emoji: '🛡️' },
  { id: 'credit',        emoji: '🏦' },
  { id: 'taxeFonciere',  emoji: '🏛️' },
  { id: 'transport',     emoji: '🚗' },
  { id: 'abonnements',   emoji: '🔁' },
  { id: 'import',        emoji: '📥' },   // catégorie technique (import bancaire)
  { id: 'remboursement', emoji: '↩️' },   // posée par le bouton « Rembourser »
  { id: 'autre',         emoji: '🏷️' },
];
// Catégories proposées À LA SAISIE : `import` et `remboursement` sont posées par
// le code, jamais choisies à la main.
export const CATEGORIES_SAISIE = CATEGORIES.filter(c => c.id !== 'import' && c.id !== 'remboursement');

// ── Registre des catégories PERSONNALISÉES (15/08) ──────────────
// Une quinzaine d'écrans résolvent l'emoji d'une catégorie par son id ; leur
// passer la config à tous serait un fil à tirer sans fin. Les écrans RACINES
// posent donc ici les personnalisées de l'espace dès qu'ils les écoutent, et
// les helpers les consultent en premier. Repli 🏷️ tant que rien n'est posé —
// dégradé, jamais faux.
let PERSO = [];
export const definirCategoriesPerso = (liste) => { PERSO = liste || []; };
const perso = (id) => PERSO.find(c => c.id === id);

export const emojiCategorie = (id) =>
  perso(id)?.emoji
  || (CATEGORIES.find(c => c.id === id) || CATEGORIES[CATEGORIES.length - 1]).emoji;

// Le NOM d'une personnalisée n'a pas de clé i18n — il est à elle. Les écrans
// qui affichent `t(cleCategorie(id))` reçoivent 'budget.cat_autre' en repli ;
// ceux qui veulent le vrai nom passent par `nomCategorie(id, t)`.
export const nomCategorie = (id, t) => perso(id)?.nom || t(cleCategorie(id));
export const cleCategorie = (id) => `budget.cat_${CATEGORIES.some(c => c.id === id) ? id : 'autre'}`;

export const TYPES_PAIEMENT = [
  { id: 'cb',        emoji: '💳' },
  { id: 'virement',  emoji: '↔️' },
  { id: 'cheque',    emoji: '📝' },
  { id: 'espece',    emoji: '💵' },
];
export const clePaiement = (id) => `budget.pmt_${id}`;

// Emoji d'une ENVELOPPE. Le canon de la suite est `emoji`, mais les budgets
// hérités de MoPCal portent encore `icone` (la migration du canon avait couvert
// calendriers/inventaires/plans, pas les budgets) : sans ce repli, toutes les
// enveloppes s'affichent avec le 💰 générique au lieu de leur 🏠 ou 🏫.
export const emojiBudget = (b) => (b && (b.emoji || b.icone)) || '💰';

// Emoji d'un POSTE budgétaire (choisi à la création).
export const EMOJIS_BUDGET = [
  '💰', '🛒', '🏫', '🩺', '⚽', '👕', '🍔', '🎁',
  '✈️', '🏠', '🚗', '📚', '🐾', '💊', '🎀', '🎉',
];
